module.exports = __webpack_public_path__ + "img/tg_03 (1).7b839682.jpg";